import { FlexContainer, Icon, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { useFlags } from 'Hooks/useFlags';
import { FlagsKey } from 'Types/common';
import * as Styled from './styles';

const PreviousYearsUpsell = ({ amount }: { amount: number }): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const { enabled } = useFlags(FlagsKey.MGM_FLOW_ENABLED);

  return (
    <Styled.UpsellContainer direction="column" align="center" justify="center" gap="dimension_24">
      <FlexContainer direction="column" gap="dimension_16">
        <Text type="headline" size="XS_L_S" color="dark">
          {t('PreviousYearsUpsell.title', { context: enabled && 'noMgm' })}
        </Text>
        <Text type="paragraphs" size="M_S_S" color="dark">
          {t('PreviousYearsUpsell.subtitle')}
        </Text>
      </FlexContainer>
      <FlexContainer
        direction="column"
        gap="dimension_24"
        fullWidth
        align="center"
        justify="center"
      >
        {!enabled && (
          <FlexContainer gap="dimension_08">
            <Icon icon="StarM" color="default" />
            <Styled.InfoContainer direction="column" gap="dimension_08">
              <Text type="paragraphs" size="M_L_S" color="dark">
                {t('Mgm.title')}
              </Text>
              <Text type="paragraphs" size="S_S_S" color="dark">
                {t('Mgm.subtitle')}
              </Text>
              <FlexContainer direction="column">
                <Text type="paragraphs" size="XS_M_S" color="grey">
                  {t('Mgm.total')}
                </Text>
                <Text type="headline" size="S_M_L" color="dark">
                  {t('Mgm.price')}
                </Text>
              </FlexContainer>
            </Styled.InfoContainer>
          </FlexContainer>
        )}
        <FlexContainer gap="dimension_08">
          <Icon icon="SheetM" color="default" />
          <Styled.InfoContainer direction="column" gap="dimension_08">
            <Text type="paragraphs" size="M_L_S" color="dark">
              {t('PreviousYear.option.title')}
            </Text>
            <Text type="paragraphs" size="S_S_S" color="dark">
              {t('PreviousYear.option.subtitle')}
            </Text>
            <FlexContainer direction="column">
              <Text type="paragraphs" size="XS_M_S" color="grey">
                {t('PreviousYear.option.total')}
              </Text>
              <Text type="headline" size="S_M_L" color="fresh">
                {YayoyakiFormatter.formatAmountMxn(amount)}
              </Text>
            </FlexContainer>
          </Styled.InfoContainer>
        </FlexContainer>
      </FlexContainer>
    </Styled.UpsellContainer>
  );
};

export default PreviousYearsUpsell;
